import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import BusinessIcon from '@material-ui/icons/Business';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ApartmentIcon from '@material-ui/icons/Apartment';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ReceiptIcon from '@material-ui/icons/Receipt';
import GavelIcon from '@material-ui/icons/Gavel';
import PaymentIcon from '@material-ui/icons/Payment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import DescriptionIcon from '@material-ui/icons/Description';
import PublicIcon from '@material-ui/icons/Public';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import CategoryIcon from '@material-ui/icons/Category';
import EmailIcon from '@material-ui/icons/Email';
import InfoIcon from '@material-ui/icons/Info';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import LockIcon from '@material-ui/icons/Lock';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';

import { getTrans as t } from "../Localization/translations";
import { useSubscriptionFeatures } from "../contexts/SubscriptionContext";

const TileSettings = () => {
  const navigate = useNavigate();
  const [showLockTooltip, setShowLockTooltip] = useState(null);
  const { planFeatures, loading } = useSubscriptionFeatures();
  const [planName, setPlanName] = useState('');

  // Map tile names to feature keys from the plan
  const featureMap = {
    'Contract Import (AI)': 'contract_import_ai',
    'Import': 'import_data',
    'Subscription (Stripe)': 'subscription_stripe',
    'Approval': 'approvals',
    'Customer Portal': 'customer_portal',
    'Tax Engine': 'avalara_tax_integration',
  };

  // Check if a feature is available
  const isFeatureAvailable = (tileName) => {
    if (!planFeatures || planFeatures === "LEGACY") return true;

    const featureKey = featureMap[tileName];
    if (!featureKey) return true;

    return planFeatures[featureKey] !== false;
  };

  const settingsSections = [
    {
      header: "Profile",
      tiles: [
        // { name: "Company Profile", icon: <BusinessIcon />, link: "/profile", desc: "Manage company details" },
        // { name: "Subscription", icon: <CreditCardIcon />, link: "/payment", desc: "Manage subscription" },
        { name: "Accounts", icon: <CreditCardIcon />, link: "/subscription", desc: "Manage Accounts" },
        { name: "Companies", icon: <ApartmentIcon />, link: "/companies", desc: "Manage companies" },
        { name: "Lines of Business", icon: <ListAltIcon />, link: "/lines-of-business", desc: "Manage LOBs" },
        // { name: "Accounts", icon: <LocationCityIcon />, link: "/subscription", desc: "Manage clients" }
        { name: "Products", icon: <AccountTreeIcon />, link: "/products", desc: "Manage products" }
      ]
    },
    {
      header: "Processing",
      tiles: [
        { name: "Processing", icon: <SettingsApplicationsIcon />, link: "/processing", desc: "Manage processing" },
        { name: "Processing Error Log", icon: <ErrorOutlineIcon />, link: "/processing-failure-log", desc: "View Error & Skip records" },
        { name: "Approval", icon: <VerifiedUserIcon />, link: "/all-approvals", desc: "Manage approvals" },
        { name: "Tax Engine", icon: <SettingsInputComponentIcon />, link: "/tax-engine", desc: "Test the Avalara connection" },

      ]
    },
    {
      header: "Import",
      tiles: [
        { name: "Contract Import (AI)", icon: <ImportExportIcon />, link: "/contractimport", desc: "Manage Contract data import" },
        { name: "Contract JSON Import", icon: <CloudUploadIcon />, link: "/contract-json-import", desc: "Bulk import contracts via JSON" },
        { name: "Import", icon: <CloudUploadIcon />, link: "/import", desc: "Manage bulk data import" },
        { name: "API Keys", icon: <VpnKeyIcon />, link: "/api-keys", desc: "Generate and manage API keys" }

      ]
    },
    {
      header: "Accounting",
      tiles: [
        { name: "Accounts", icon: <AccountBalanceWalletIcon />, link: "/accounts", desc: "Manage accounts" },
        { name: "Transactions", icon: <ReceiptIcon />, link: "/transactiontypes", desc: "Manage transactions" },
        { name: "Rules", icon: <GavelIcon />, link: "/accountingsetup", desc: "Manage rules" }
      ]
    },
    {
      header: "Payments",
      tiles: [
        { name: "Subscription (Stripe)", icon: <PaymentIcon />, link: "/paymentstripe", desc: "Manage stripe subscription" },
        { name: "ACH Provider", icon: <AccountBalanceIcon />, link: "/achproviders", desc: "Manage ACH provider details" },
        { name: "ACH Files", icon: <DescriptionIcon />, link: "/achfileview", desc: "View ACH files" }
      ]
    },
    {
      header: "Setting",
      tiles: [
        { name: "Global Setting", icon: <PublicIcon />, link: "/additionalsettings", desc: "Manage global settings" },
        { name: "Party Roles", icon: <GroupAddIcon />, link: "/party-roles", desc: "Manage party roles" }, 
        { name: "Rate Card", icon: <MonetizationOnIcon />, link: "/ratecard", desc: "Manage rate cards" },
        { name: "Tax Rates", icon: <LocalOfferIcon />, link: "/taxrateview", desc: "Manage tax rates" },
        { name: "Inventory Categories", icon: <CategoryIcon />, link: "/categories", desc: "Manage inventory categories" },
        { name: "Expenses & Fee ", icon: <CategoryIcon />, link: "/expense-categories", desc: "Manage expenses & fee categories" },
        { name: "Email Templates", icon: <EmailIcon />, link: "/emailtemplets", desc: "Manage email templates" },
        { name: "Additional Information", icon: <InfoIcon />, link: "/AdditionalFiled", desc: "Manage extra fields" },
        { name: "Terms & Conditions", icon: <GavelIcon />, link: "/term-condition", desc: "Manage Terms & Conditions" },
        // { name: "API Keys", icon: <VpnKeyIcon />, link: "/api-keys", desc: "Generate and manage API keys" }
      ]
    }
  ];

  const handleTileClick = (tile, e) => {
    if (!isFeatureAvailable(tile.name)) {
      e.preventDefault();
      setShowLockTooltip(tile.name);
      setTimeout(() => setShowLockTooltip(null), 2000);
      return;
    }
    navigate(tile.link);
  };

  if (loading) {
    return (
      <div className="container-fluid p-4" style={{ backgroundColor: '#F0F2F5', minHeight: '100vh' }}>
        <div className="text-center p-5">
          <p style={{ color: '#44566C', fontSize: '16px' }}>Loading settings...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4" style={{ backgroundColor: '#F0F2F5', minHeight: '100vh' }}>
      {settingsSections.map((section, index) => (
        <div key={index} className="mb-5">
          <h5 className="mb-3 fw-bold" style={{ color: '#44566C' }}>{t(section.header)}</h5>
          <div className="row g-4">
            {section.tiles.map((tile, tIndex) => {
              const isDisabled = !isFeatureAvailable(tile.name);
              
              return (
                <div key={tIndex} className="col-12 col-md-6 col-lg-4 col-xl-3" style={{ position: 'relative' }}>
                  <div
                    className={`card h-100 border-0 shadow-sm ${isDisabled ? 'tile-disabled' : 'tile-hover'}`}
                    style={{
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      borderRadius: '8px',
                      backgroundColor: isDisabled ? '#E8EAED' : '#fff',
                      opacity: isDisabled ? 0.6 : 1,
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      border: isDisabled ? '1px solid #BDBDBD' : 'none'
                    }}
                    onClick={(e) => handleTileClick(tile, e)}
                    onMouseEnter={() => isDisabled && setShowLockTooltip(tile.name)}
                    onMouseLeave={() => isDisabled && setShowLockTooltip(null)}
                  >
                    <div className="card-body d-flex align-items-start p-3">
                      <div 
                        className="me-3 mt-1" 
                        style={{ 
                          color: isDisabled ? '#BDBDBD' : '#2C5D7E',
                          transition: 'color 0.3s ease'
                        }}
                      >
                        {React.cloneElement(tile.icon, { fontSize: "large" })}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <h6 
                            className="card-title fw-bold mb-1 text-dark"
                            style={{ 
                              color: isDisabled ? '#9E9E9E' : '#1a1a1a',
                              marginBottom: '0.5rem'
                            }}
                          >
                            {t(tile.name)}
                          </h6>
                        </div>
                        <p 
                          className="card-text small mb-0"
                          style={{ 
                            color: isDisabled ? '#BDBDBD' : '#6B7280'
                          }}
                        >
                          {isDisabled ? 'Premium feature - Upgrade to access' : t(tile.desc)}
                        </p>
                      </div>
                    </div>
                  </div>            
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <style jsx>{`
        .tile-hover:hover {
          transform: translateY(-3px);
          box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
        }
      `}</style>
    </div>
  );
};

export default TileSettings;